export default {
  state: {
    items: [
      {
        value: 'econom',
        text: 'Econom'
      },
      {
        value: 'comfortplus',
        text: 'Comfort Plus'
      },
      {
        value: 'maybach',
        text: 'Maybach'
      },
      {
        value: 'ultimate',
        text: 'Ultimate'
      },
      {
        value: 'business',
        text: 'Business'
      },
      {
        value: 'child_tariff',
        text: 'Child Tariff'
      },
      {
        value: 'vip',
        text: 'Vip'
      }
    ]
  }
}
